import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var persInfs = [{
  label: "masc. sing.",
  value: "mascSing"
}, {
  label: "fem. sing.",
  value: "femSing"
}, {
  label: "masc. plur.",
  value: "mascPlur"
}, {
  label: "fem. plur",
  value: "femPlur"
}];

function PersInfsPicker(props) {
  function hChange(e) {
    var newValue = e.target.value;
    props.handleChange(newValue);
  }

  return _jsxs("div", Object.assign({
    className: "my-2",
    style: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center"
    }
  }, {
    children: [_jsxs("div", Object.assign({
      className: "mr-2"
    }, {
      children: ["When the ", _jsx("strong", {
        children: props.transitivity === "intransitive" ? "subject" : "object"
      }, void 0), " is"]
    }), void 0), _jsx("div", {
      children: _jsx("select", Object.assign({
        className: "form-control form-control-sm d-inline-block",
        value: props.persInf,
        id: "verb_info_pers_select",
        onChange: hChange
      }, {
        children: persInfs.map(function (pers) {
          return _jsx("option", Object.assign({
            value: pers.value
          }, {
            children: pers.label
          }), pers.value);
        })
      }), void 0)
    }, void 0)]
  }), void 0);
}

export default PersInfsPicker;